import * as layout from '../../../components/markLayout.module.css';
import Section from '@hero/ui-kit/layout/Section';
import MarkModal from '../../../components/MarkModal';
import { MarkButton, MarkHeading } from '../../../components/MarkControls';
import React, { useId } from 'react';
import P from '@hero/ui-kit/typography/P';
import usePauseDrip from '../../../api/usePauseDrip';
import { useNotifications } from '../../../../../context/notification';
import { extractDripErrorMessage } from '../dripFormUtils';
import type { DripDetail } from '../../../types';
type Props = {
    drip: DripDetail;
    onClose: () => void;
    onSuccess: () => void;
};
const PauseModal: React.FC<Props> = ({ drip, onClose, onSuccess }) => {
    const pause = usePauseDrip();
    const { addNotification } = useNotifications();
    const headingId = useId();
    const handleConfirm = () => {
        pause.mutate(
            { drip_id: drip.drip_id },
            {
                onSuccess: () => {
                    addNotification({ type: 'success', message: 'Drip paused.' });
                    onSuccess();
                }
            }
        );
    };
    return (
        <MarkModal
            onClose={onClose}
            isPending={pause.isPending}
            aria-labelledby={headingId}
            styles={{
                width: 'min(64rem, 90vw)'
            }}
        >
            <Section noDefaultPadding className={layout.form}>
                <MarkHeading
                    role="h4"
                    id={headingId}
                    tabIndex={-1}
                    style={{
                        margin: '0 0 1rem'
                    }}
                >
                    Pause drip
                </MarkHeading>
                <P
                    noDefaultMargin
                    styles={{
                        marginBottom: '0.8rem'
                    }}
                >
                    Pausing stops the cron from advancing instances. Running instances hold in place
                    until you Activate to resume.
                </P>
                {pause.error && (
                    <div
                        role="alert"
                        style={{
                            marginTop: '0.8rem'
                        }}
                        className={layout.notice}
                    >
                        <P
                            noDefaultMargin
                            size="small"
                            styles={{
                                color: 'var(--mark-danger)'
                            }}
                        >
                            {extractDripErrorMessage(pause.error)}
                        </P>
                    </div>
                )}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '0.8rem',
                        marginTop: '1.6rem'
                    }}
                >
                    <MarkButton type="button" onClick={onClose} disabled={pause.isPending}>
                        Cancel
                    </MarkButton>
                    <MarkButton type="button" onClick={handleConfirm} disabled={pause.isPending}>
                        {pause.isPending ? 'Pausing…' : 'Pause'}
                    </MarkButton>
                </div>
            </Section>
        </MarkModal>
    );
};
export default PauseModal;
